import { gql, useMutation } from '@apollo/client';
import { useNavigate, useParams } from 'react-router';
import { UpsertTeamMembersMutation } from '../../mutations';
import {
  getFirstMutationResult,
  getFirstQueryResult,
} from '../../utils/graphql';
import { useQueryWithMsg } from '../../utils/hooks';
import { navigateToPortal } from '../../utils/utils';
import MembersContent from './MembersContent';
import OnboardingLayout from './OnboardingLayout';
import useMutateWithState from '../../hooks/useMutateWithState';

const MemberQuantityQuery = gql`
  query MemberQuantityQuery($id: ID!) {
    teamStripeState(id: $id) {
      id
      name
      updatedAt
      stripeSubscription {
        id
        quantity
      }
    }
  }
`;

const InviteMembers = () => {
  const navigate = useNavigate();
  const { teamId } = useParams();
  const { msg, data: existingTeamData } = useQueryWithMsg(MemberQuantityQuery, {
    variables: { id: teamId },
  });

  const [, mutateAndSetState] = useMutateWithState();
  const [upsertTeamMembers] = useMutation(UpsertTeamMembersMutation);

  const team = getFirstQueryResult(existingTeamData);

  // Subtract 1 for the current user who is set to admin at team creation
  const seats = team?.stripeSubscription?.quantity;
  const seatsMinusAdmin = seats != null ? seats - 1 : 0;

  return (
    <OnboardingLayout image="/images/onboard4.webp">
      {msg ? (
        <h2>{msg}</h2>
      ) : (
        <MembersContent
          onCompleted={({ members }) => {
            const navigateToTeam = () =>
              navigate(`/app/team/${team?.id}/farms`, { replace: true });
            if (members.length === 0) {
              navigateToTeam();
            }
            return mutateAndSetState(() =>
              upsertTeamMembers({
                variables: {
                  input: {
                    updatedAt: team?.updatedAt,
                    id: teamId,
                    members,
                  },
                },
              }),
            ).then((response) => {
              const result = getFirstMutationResult(response.data);
              if (result) {
                // Don't include this url in the location history
                navigateToTeam();
              }
            });
          }}
          onEditPlan={() =>
            navigateToPortal({
              teamId: team?.id,
            })
          }
          seats={seatsMinusAdmin}
        />
      )}
    </OnboardingLayout>
  );
};

export default InviteMembers;
